module.exports = __webpack_public_path__ + "img/size-detail-bnd.261af898.png";